// extracted by mini-css-extract-plugin
module.exports = {"fundInFocus":"FundInFocus_fundInFocus__734gg"};